import { IconUserShield } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import classes from './ViewerRoles.module.css';

/**
 * Pano başlığında kişinin rolleri (04.11 notları C3): "Your roles: Fleet Manager, Office Manager".
 * Rol adları şirketin verdiği adlardır (çevrilmez); rol yoksa ya da eski sunucu göndermediyse
 * hiçbir şey çizilmez.
 */
export function ViewerRoles({ roles }: { roles: readonly string[] | undefined }) {
  const { t } = useTranslation();
  if (!roles || roles.length === 0) return null;
  return (
    <p className={classes.roles} data-testid="viewer-roles">
      <IconUserShield size={15} stroke={1.8} aria-hidden />
      <span>{t('tasks.roles', { count: roles.length, roles: roles.join(', ') })}</span>
    </p>
  );
}
